import { queryOptions, useQuery } from '@tanstack/react-query';
import { customFetch } from '~/utils/customFetch';

import {
  staffGlobalStatColumnCatalogResponseSchema,
  type StaffGlobalCatalogScope,
  type StaffGlobalStatColumnCatalogResponse,
} from './staffGlobalStatColumnCatalogSchema';

export type {
  StaffGlobalCatalogScope,
  StaffGlobalStatCatalogRow,
  StaffGlobalStatColumnCatalogResponse,
  StaffGlobalStatDiscoveryEntry,
} from './staffGlobalStatColumnCatalogSchema';

const fetchStaffGlobalStatColumnCatalog = async (
  scope?: StaffGlobalCatalogScope,
): Promise<StaffGlobalStatColumnCatalogResponse> => {
  const params = scope ? { scope } : undefined;
  const { data } = await customFetch.get<unknown>('/authenticated/staff/analytics/column-catalog', {
    headers: { 'Content-Type': 'application/json' },
    useNodeEndpoint: true,
    params,
  });
  return staffGlobalStatColumnCatalogResponseSchema.parse(data);
};

export const getStaffGlobalStatColumnCatalogQueryOptions = (scope?: StaffGlobalCatalogScope) =>
  queryOptions({
    queryKey: ['staff', 'global-stat-column-catalog', scope ?? 'all'],
    queryFn: () => fetchStaffGlobalStatColumnCatalog(scope),
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });

export const useStaffGlobalStatColumnCatalogQuery = (scope?: StaffGlobalCatalogScope) =>
  useQuery(getStaffGlobalStatColumnCatalogQueryOptions(scope));
